import {
  IgetTenantsBody,
  IInitialSuperAdminState,
} from 'interfaces/superAdmin.interface';

const getTenantsBody: IgetTenantsBody = {
  scope: 'tenant',
  populated: true,
  country_id: '',
  search: '',
  index: 0,
  limit: 40,
};

const initialSuperAdminState: IInitialSuperAdminState = {
  tenants: [],
  tenantsBody: getTenantsBody,
  isLoadingMoreTenants: false,
  thereAreMoreTenants: true,
  getMoreTenants: () => Promise.resolve(false),
  tenantsWithUsers: [],
  getTenantsWithUsers: () => Promise.resolve(false),
  isLoadingGetTenantsWithUsers: false,
  clients: [],
  isLoading: true,
  removeUserClient: () => {},
  addUserClient: () => {},
  getConnectors: async () => Promise.resolve(false),
  connectors: {
    shopify: [],
    sftp: [],
  },
  isLoadingConnectors: false,
  // Map fields
  getMapFields: () => Promise.resolve(false),
  isLoadingMapFields: false,
  mapFields: [],
  createMapField: () => Promise.resolve(false),
  isLoadingCreateMapField: false,
  updateMapField: () => Promise.resolve(false),
  isLoadingUpdateMapField: false,
  deleteMapField: () => Promise.resolve(false),
  isLoadingDeleteMapField: {
    loading: false,
    mapFieldId: '',
  },
  // Map fields templates
  getMapFieldsTemplates: () => Promise.resolve(false),
  isLoadingMapFieldsTemplates: false,
  mapFieldsTemplates: [],
  createMapFieldsTemplate: () => Promise.resolve(false),
  isLoadingCreateMapFieldsTemplate: false,
  deleteMapFieldTemplate: () => Promise.resolve(false),
  isLoadingDeleteMapFieldTemplate: {
    loading: false,
    templateName: '',
  },
  shopify: {
    // Queries
    getShopifyQueries: () => Promise.resolve(false),
    isLoadingQueries: false,
    queries: [],
    selectShopifyQuery: () => {},
    querySelected: null,
    createShopifyQuery: () => Promise.resolve(false),
    isLoadingCreateQuery: false,
    deleteShopifyQuery: () => Promise.resolve(false),
    isLoadingDeleteQuery: {
      loading: false,
      queryId: '',
    },
    updateShopifyQuery: () => Promise.resolve(false),
    isLoadingUpdateQuery: false,
    // Templates
    getShopifyTemplates: () => Promise.resolve(false),
    templates: [],
    isLoadingTemplates: false,
    selectShopifyTemplate: () => {},
    templateSelected: null,
    createUpdateShopifyTemplate: () => Promise.resolve(false),
    isLoadingCreateUpdateTemplate: false,
    deleteShopifyTemplate: () => Promise.resolve(false),
    isLoadingDeleteTemplate: {
      loading: false,
      templateTag: '',
    },
  },
};

export default initialSuperAdminState;
